import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class GroupsService {

	baseUrl = `${environment.apis.base}/groups`;

	constructor(private readonly http: HttpClient) { }

	datatable(page?: number, options?: any): Observable<Object> {
		let httpParams = new HttpParams();

		if (typeof page === 'number') {
			httpParams = httpParams.append('page', page);
		}

		if ('key' in options && options.key.trim() !== '') {
			httpParams = httpParams.append('search', options.key);
		}
		if (options && 'client_id' in options && options.client_id) {
			httpParams = httpParams.append('client_id', options.client_id);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

	getAll(): Promise<any> {
		return this.http.get(`${this.baseUrl}/getAll/getGroups`).toPromise();
	}

	show(id: number): Promise<any> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			return this.http.put<any>(url, data.value);
		} else {
			return this.http.post<any>(url, data.value);
		}
	}

	saveUnits(data: any, id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}/save-units`;
		return this.http.post<any>(url, { units: data });
	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}

	generateZip(): Observable<Object> {
		const url = `${this.baseUrl}/util/zip`;

		return this.http.get<any>(url);
	}
}
